<template>
  <div
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-input" v-if="!fieldObj.disabled">
      <div class="m-file-wap" v-if="!fieldObj.value">
        <div class="u-upload-tips">
          <i class="icontemp jia"></i>
          <span>点击添加文件</span>
        </div>
        <input
          type="file"
          class="file-input"
          title=""
          @change="changeFile"
          :accept="fieldObj.accept"
          :value="fieldObj.value ? '' : null"
        />
      </div>

      <div class="m-file-wap" v-if="fieldObj.value">
        <div class="u-file-name">
          {{ fieldObj.value ? fieldObj.value.fileName : "" }}
        </div>
        <div class="u-delete-icon" @click="clearFile">
          <span class="icontemp stemp-close"></span>
        </div>
      </div>
    </div>
     <a-input
      v-if="fieldObj.disabled"
      class="status-input"
      disabled
      :value="fieldObj.value ? fieldObj.value.fileName : ''"
    />
    <div class="u-reg-item-tips-wap">文件大小限制：300M</div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import fileMixin from "../../field/new-fields/file";
export default {
  name: "sk-file-wap",
  mixins: [fileMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
</style>
